// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero-module--root--2aLmy","heading":"Hero-module--heading--22x7O"};